import React, { Component } from "react";
import "./stylesheets/workdetails.css";
import Header from "../../components/header/Header";
import { getJobDetails } from "../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { BsCheckCircleFill } from "react-icons/bs";
import { TiDelete } from "react-icons/ti";
import { MdCancel } from "react-icons/md";
import { FaUserClock, FaCheck, FaClock } from "react-icons/fa";
import { IoCheckmarkCircle, IoCheckmarkDoneCircle } from "react-icons/io5";

export default class WorkDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobdetails: "",
      jobtype: "",
      currnetmonth: "",
      currnetyear: "",
      jobdate: "",
      loading: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const cusId = readData.userdata.user_id;
    let params = new URLSearchParams(window.location.pathname);
    var month = params.get("month");
    var year = params.get("year");
    var jobid = params.get("jobid");
    var jobtype = params.get("jobtype");
    var jobdate = params.get("jobdate");
    var sendData = {
      month: month,
      year: year,
      jobtype_id: parseInt(jobid),
      cusId: cusId,
    };
    this.setState({ currnetyear: year, currnetmonth: month, jobdate: jobdate });
    const fetchjobdetails = async () => {
      this.setState({
        loading: true,
      });
      const responsejobs = await getJobDetails(sendData);
      const datarespjobs = await responsejobs;
      if (datarespjobs) {
        this.setState({
          loading: false,
        });
      } else {
        this.setState({
          loading: false,
        });
      }
      this.setState({
        jobdetails: datarespjobs,
        jobtype: jobtype,
      });
    };
    fetchjobdetails();
  }

  render() {
    const loadingImg = require("../../assets/images/Hourglass.gif");

    var jobdetailsdata = this.state.jobdetails;
    var jobdetails = "";
    var jobdetailsDataArr = [];
    if (
      jobdetailsdata !== "" &&
      jobdetailsdata !== null &&
      jobdetailsdata !== undefined
    ) {
      jobdetails = this.state.jobdetails;
      for (var i = 0; i < jobdetails.length; i++) {
        var jobdetailsDataMain = {};
        var startDateData = new Date(jobdetails[i].StartDateTime);
        var startDate = startDateData.toLocaleString("en-IN", {
          dateStyle: "medium",
        });
        var startTime = startDateData.toLocaleString("en-IN", {
          timeStyle: "short",
        });
        var endDateData = new Date(jobdetails[i].EndDateTime);
        var endDate = endDateData.toLocaleString("en-IN", {
          dateStyle: "medium",
        });
        var endTime = endDateData.toLocaleString("en-IN", {
          timeStyle: "short",
        });
        jobdetailsDataMain["CustomerName"] = jobdetails[i].CustomerName;
        jobdetailsDataMain["ConveyorReference"] =
          jobdetails[i].ConveyorReference;
        jobdetailsDataMain["startDate"] =
          startDate + " " + startTime.toUpperCase();
        jobdetailsDataMain["endDate"] = endDate + " " + endTime.toUpperCase();
        jobdetailsDataMain["Measures"] = jobdetails[i].Measures;
        jobdetailsDataMain["TechNames"] = jobdetails[i].TechNames;
        jobdetailsDataMain["Department"] = jobdetails[i].Department;
        jobdetailsDataMain["Status"] = jobdetails[i].Status;
        jobdetailsDataArr.push(jobdetailsDataMain);
      }
    }
    const backLogoCircle = require("../../assets/images/backBtnCircle.png");
    return (
      <div>
        <Header />
        <div className="container">
          <div className="col-md-4 cardMainDataSyTask mb-3">
            <div className="p-card rounded px-3">
              <p className="mt-2 headingMain">{this.state.jobtype}</p>
              <Link
                className=""
                to={
                  "/my-work/&month=" +
                  this.state.currnetmonth +
                  "&year=" +
                  this.state.currnetyear +
                  "&jobdate=" +
                  this.state.jobdate
                }
              >
                <img
                  className="backBtn"
                  src={backLogoCircle}
                  alt="back"
                  width="25"
                  height="20"
                />
              </Link>
            </div>
          </div>
          <div className="row rowDataClass">
            {jobdetailsDataArr.length > 0
              ? jobdetailsDataArr.map((jobdetails, index) => (
                  <div className="col-sm-6 mb-3" key={index}>
                    <div className="card card-task">
                      <div className="card-body card-body-task">
                        <h5 className="calenderDate">
                          {jobdetails.startDate + " - " + jobdetails.endDate}{" "}
                        </h5>
                        <h5 className="card-title">
                          {jobdetails.CustomerName}
                        </h5>
                        <p className="card-text-primary">
                          {jobdetails.ConveyorReference +
                            " - " +
                            jobdetails.Department}
                        </p>
                        <p className="card-text-primary">
                          {jobdetails.Measures}
                        </p>
                        <p className="card-text-primary">
                          {jobdetails.TechNames}
                        </p>
                        {/* <p className="card-text-primary">
                          <b>Job # </b>
                          {jobdetails.JobID}
                        </p> */}
                        {jobdetails.Status ? (
                          <p className="card-title statusClassData">
                            {jobdetails.Status === 10 ? (
                              <span>
                                {" "}
                                Created{" "}
                                <BsCheckCircleFill className="appClassData" />{" "}
                              </span>
                            ) : (
                              ""
                            )}
                            {jobdetails.Status === 20 ? (
                              <div className="d-flex flex-column">
                                <span>
                                  {" "}
                                  Branch Rejected{" "}
                                  <MdCancel
                                    style={{
                                      color: "red",
                                    }}
                                    size={20}
                                  />
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                            {jobdetails.Status === 30 ? (
                              <span>
                                {" "}
                                Branch Hold{" "}
                                <FaClock
                                  style={{
                                    color: "orangered",
                                  }}
                                  size={20}
                                />
                              </span>
                            ) : (
                              ""
                            )}
                            {jobdetails.Status === 60 ? (
                              <span>
                                {" "}
                                Validated{" "}
                                <IoCheckmarkCircle className="appClassData" />
                              </span>
                            ) : (
                              ""
                            )}
                            {jobdetails.Status === 70 ? (
                              <span>
                                {" "}
                                HO Rejceted{" "}
                                <MdCancel
                                  style={{
                                    color: "red",
                                  }}
                                  size={20}
                                />
                              </span>
                            ) : (
                              ""
                            )}
                            {jobdetails.Status === 80 ? (
                              <span>
                                {" "}
                                HO Hold{" "}
                                <FaClock
                                  style={{
                                    color: "orangered",
                                  }}
                                  size={20}
                                />
                              </span>
                            ) : (
                              ""
                            )}
                            {jobdetails.Status === 90 ? (
                              <span>
                                {" "}
                                HO Approved{" "}
                                <IoCheckmarkDoneCircle
                                  size={20}
                                  className="appClassData"
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                ))
              : ""}
          </div>
        </div>
        {this.state.loading === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
